module.exports = __webpack_public_path__ + "img/img_11.6e175122.svg";